<script setup>
defineProps({
  loading: Boolean,
  error: { type: String, default: '' },
  success: { type: String, default: '' },
  loadingText: { type: String, default: 'Завантаження…' },
  retryable: { type: Boolean, default: true },
})
defineEmits(['retry'])
</script>

<template>
  <div v-if="loading" class="alert alert-info d-flex align-items-center gap-2" role="status">
    <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>{{ loadingText }}
  </div>
  <div v-else-if="error" class="alert alert-danger d-flex justify-content-between align-items-center gap-3" role="alert" aria-live="assertive">
    <span>{{ error }}</span>
    <button v-if="retryable" class="btn btn-sm btn-outline-danger flex-shrink-0" type="button" @click="$emit('retry')">Повторити</button>
  </div>
  <div v-else-if="success" class="alert alert-success" role="status" aria-live="polite">{{ success }}</div>
</template>
